/* ============
 * Transformer
 * ============
 *
 * The base transformer.
 *
 * Transformers are used to transform the fetched data
 * to a more suitable format.
 * For instance, when the fetched data contains snake_cased values,
 * they will be camelCased.
 */

export default class Transformer {
  /**
   * Method used to transform a fetched collection
   *
   * @param items The items to be transformed
   * @returns {Array} The transformed items
   */
  static fetchCollection(items) {
    // Le contrat d'API ne garantit pas une liste : page d'erreur HTML d'un
    // backend absent, objet Hydra si l'en-tête `Accept` change, payload modifié…
    // Transformer cela en écran vide plutôt qu'en TypeError qui casse la page
    // et laisse son spinner tourner (même raison que SP-13947).
    if (!Array.isArray(items)) {
      window.console.error(`${this.name}.fetchCollection: unexpected API payload`, items);
      return [];
    }
    return items.map((item) => this.fetch(item));
  }

  /**
   * Method used to transform a collection to be send
   *
   * @param items The items to be transformed
   * @returns {Array} The transformed items
   */
  static sendCollection(items) {
    return items.map((item) => this.send(item));
  }
}
